import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { useTheme } from '../context/ThemeContext';


export default function Settings() {
  const navigate = useNavigate();
  const { mode, toggleTheme } = useTheme();

  return (
    <Box sx={{ maxWidth: 720, mx: 'auto', p: { xs: 2, md: 5 } }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>Paramètres</Typography>
        <Typography sx={{ mb: 3 }}>
          Thème actuel : {mode === 'dark' ? 'soirée douce' : 'clair naturel'}.
          Les deux palettes évitent le noir absolu et utilisent les mêmes composants.
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <Button variant="contained" onClick={toggleTheme}>Changer de thème</Button>
          <Button variant="outlined" onClick={() => navigate('/')}>Retour</Button>
        </Box>
      </Paper>
    </Box>
  );
}
